import {
  Box,
  Flex,
  Grid,
  GridItem,
  PopoverContent,
  PopoverCloseButton,
  Radio,
  RadioGroup,
  Text,
  Button,
  Input,
  Spinner,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";

export interface IFilterItem {
  id: number;
  name: string;
}
export interface IFilter {
  id: number;
  name: string;
  parentId?: number;
}
export interface IRelation {
  parent: string;
  child: string;
}
export interface IFilterOptions {
  filterOptions: Record<string, IFilter[]>;
  relations?: IRelation[];
}

export interface GlobalFilterProps {
  filter: IFilterOptions;
  selectedFilters?: Record<string, number[]>;
  onApply: (filters: Record<string, number[]>) => void;
}

const FilterCard = ({
  filter: filters,
  selectedFilters = {},
  onApply,
}: GlobalFilterProps) => {
  const categories = Object.keys(filters.filterOptions || {});

  const [activeCategory, setActiveCategory] = useState("");
  const [selected, setSelected] = useState<Record<string, number[]>>(selectedFilters);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (categories.length > 0 && !activeCategory) {
      setActiveCategory(categories[0]);
    }
  }, [categories, activeCategory]);
  // RESET
  const handleReset = () => {
    setSelected({});
    setSearch('');
    onApply({});
  };
  
  useEffect(() => {
  setSearch("");
}, [activeCategory]);

useEffect(() => {
  setLoading(true);

  const timer = setTimeout(() => {
    setLoading(false);
  }, 300);

  return () => clearTimeout(timer);
}, [search]);

  // APPLY
  const handleApply = () => {
    onApply(selected);
  };

const filteredOptions = (
  filters.filterOptions[activeCategory] || []
).filter((item) =>
  item.name.toLowerCase().includes(search.toLowerCase())
);
  return (
    <PopoverContent width="450px" borderRadius="10px" p={0}>

     <PopoverCloseButton top="10px" right="10px" zIndex={9999}/>

      {/* BODY */}
      <Grid templateColumns="200px 1px 1fr" minH="280px">
        {/* LEFT SIDE */}
        <GridItem>
          <RadioGroup value={activeCategory}>
            {categories.map((category) => (
              <Flex
                key={category}
                align="center"
                gap="12px"
                px="14px"
                py="11px"
                cursor="pointer"
                borderBottom="1px solid #D9D9D9"
                bg={
                  activeCategory === category
                    ? "traparent"
                    : "#FFFFFF"
                }
                onClick={() => setActiveCategory(category)}
              >
                <Radio
                  value={category}
                  isChecked={activeCategory === category}
                />
                <Text fontSize="14px" color="#3D3D3D">
                  {category}
                </Text>
              </Flex>
            ))}
          </RadioGroup>
        </GridItem>

        {/* CENTER BORDER */}
        <GridItem bg="#D9D9D9" />

        {/* RIGHT SIDE */}
        
         <GridItem position="relative">
  <Box p="10px" borderBottom="1px solid #D9D9D9">
    <Input maxW="190px"
      size="sm"
      placeholder={`Search ${activeCategory}`}
      value={search}
      onChange={(e) => setSearch(e.target.value)}
    />
  </Box>

 <Box maxH="180px" overflowY="auto" pb="50px">
  {loading ? (
    <Flex justify="center" py={6}>
      <Spinner size="sm" />
    </Flex>
  ) : filteredOptions.length === 0 ? (
    <Flex justify="center" py={6}>
      <Text fontSize="14px" color="gray.500">
        No records found
      </Text>
    </Flex>
  ) : (
    filteredOptions.map((item) => {
      const isSelected =
        selected[activeCategory]?.includes(item.id);

      return (
        <Flex
          key={item.id}
          align="center"
          px="14px"
          py="11px"
          borderBottom="1px solid #D9D9D9"
          cursor="pointer"
          bg={isSelected ? "#EAEAEA" : "#FFFFFF"}
          onClick={() => {
            setSelected((prev) => {
              const current = prev[activeCategory] || [];

              const updated = current.includes(item.id)
                ? current.filter((id) => id !== item.id)
                : [...current, item.id];

              return {
                ...prev,
                [activeCategory]: updated,
              };
            });
          }}
        >
          <Box w="20px" h="20px" textAlign="center">
            {isSelected && (
              <Text
                fontSize="16px"
                fontWeight="bold"
                color="#000000"
              >
                ✓
              </Text>
            )}
          </Box>

          <Text
            fontSize="14px"
            color="#3D3D3D"
            ml="10px"
          >
            {item.name}
          </Text>
        </Flex>
      );
    })
  )}
</Box>

          {/* FIXED BUTTONS */}
          <Box
            position="absolute"
            bottom="8px"
            right="14px"
            bg="#FFFFFF"
          >
            <Button
              variant="ghost"
              size="sm"
              mr={2}
              onClick={handleReset}
            >
              Reset
            </Button>

            <Button
              size="sm"
              bg="#000000"
              color="#FFFFFF"
              _hover={{ bg: "#222222" }}
              onClick={handleApply}
            >
              Apply
            </Button>
          </Box>
        </GridItem>
      </Grid>
    </PopoverContent>
  );
};

export default FilterCard;